import React from 'react'
import styled, { keyframes } from 'styled-components'
import LoadingSpinner from '../../../vectors/IconSpinActivateArrows'

const LoadingArrows = () => {
  const rotate = keyframes`
    from {
      transform: rotate(0deg)
    }
    to {
      transform: rotate(719deg)
    }
  `

  const StyledLoadingSpinner = styled(LoadingSpinner)`
    animation: ${rotate} 1s infinite;
  `

  return <StyledLoadingSpinner />
}

export default LoadingArrows
